import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  const services = [
    {
      icon: 'ri-shirt-line',
      title: 'Wedding Dress Alterations',
      description: 'Expert alterations for your special day. We ensure your wedding dress fits perfectly, enhancing your natural beauty.',
    },
    {
      icon: 'ri-user-line',
      title: 'Suit Tailoring',
      description: 'Professional suit and tuxedo tailoring for the perfect fit. Look sharp and confident for any occasion.',
    },
    {
      icon: 'ri-scissors-line',
      title: 'Hem Adjustments',
      description: 'Precise hem alterations for pants, dresses, and skirts. Perfect length every time.',
    },
    {
      icon: 'ri-ruler-line',
      title: 'Custom Fitting',
      description: 'Personalized fitting services tailored to your unique measurements and style preferences.',
    },
    {
      icon: 'ri-tools-line',
      title: 'Zipper Replacement',
      description: 'Quick and reliable zipper repairs and replacements for all types of garments.',
    },
    {
      icon: 'ri-t-shirt-line',
      title: 'Garment Resizing',
      description: 'Complete resizing services to breathe new life into your favorite clothing pieces.',
    },
  ];

  const testimonials = [
    {
      name: 'Sarah Mitchell',
      role: 'Bride',
      text: 'The team at Stitch&Style transformed my wedding dress into something absolutely magical. Their attention to detail is unmatched!',
      rating: 5,
    },
    {
      name: 'James Anderson',
      role: 'Business Professional',
      text: 'I have been getting my suits tailored here for years. The quality and precision are consistently excellent.',
      rating: 5,
    },
    {
      name: 'Emily Rodriguez',
      role: 'Fashion Enthusiast',
      text: 'They saved my favorite vintage dress! The alterations were so seamless, you would never know it was modified.',
      rating: 5,
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-r from-amber-700 to-amber-900">
        <div className="absolute inset-0 opacity-30">
          <img
            src="https://public.readdy.ai/ai/img_res/8c3a061f5aaabd84a4c54fd7069a43f2.jpg"
            alt="Mobile Alteration Service"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white w-full">
          <h1 className="text-5xl md:text-7xl font-bold mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
            Premium Alterations<br />At Your Doorstep
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
            Professional tailoring services delivered to your home. No need to travel – we bring expert alterations directly to you in Newark and surrounding areas.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="bg-white text-amber-700 px-8 py-4 rounded-md font-semibold text-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer inline-block"
            >
              Schedule Home Visit
            </Link>
            <Link
              to="/services"
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-md font-semibold text-lg hover:bg-white hover:text-amber-700 transition-colors whitespace-nowrap cursor-pointer inline-block"
            >
              View Services
            </Link>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
              How Our Home Service Works
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Experience the convenience of professional alterations without leaving your home
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-8 bg-gradient-to-br from-amber-50 to-white rounded-lg shadow-md">
              <div className="w-20 h-20 flex items-center justify-center bg-amber-700 rounded-full mx-auto mb-6">
                <i className="ri-calendar-check-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
                1. Book Your Visit
              </h3>
              <p className="text-gray-600">
                Schedule a convenient time for our expert tailor to visit your home. We work around your schedule, including evenings and weekends.
              </p>
            </div>

            <div className="text-center p-8 bg-gradient-to-br from-amber-50 to-white rounded-lg shadow-md">
              <div className="w-20 h-20 flex items-center justify-center bg-amber-700 rounded-full mx-auto mb-6">
                <i className="ri-home-smile-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
                2. We Come to You
              </h3>
              <p className="text-gray-600">
                Our professional tailor arrives at your home with all necessary equipment. Try on your garments in comfort and get precise measurements.
              </p>
            </div>

            <div className="text-center p-8 bg-gradient-to-br from-amber-50 to-white rounded-lg shadow-md">
              <div className="w-20 h-20 flex items-center justify-center bg-amber-700 rounded-full mx-auto mb-6">
                <i className="ri-truck-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
                3. Delivery & Fitting
              </h3>
              <p className="text-gray-600">
                We complete the alterations and deliver your perfectly fitted garments back to your door. Final fitting adjustments available if needed.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
              Why Choose Our Mobile Service
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              The ultimate convenience meets professional expertise
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 flex items-center justify-center bg-amber-100 rounded-lg mb-4">
                <i className="ri-time-line text-3xl text-amber-700"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Save Time</h3>
              <p className="text-gray-600">
                No driving, no parking, no waiting. We fit into your busy schedule.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 flex items-center justify-center bg-amber-100 rounded-lg mb-4">
                <i className="ri-home-heart-line text-3xl text-amber-700"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Comfort</h3>
              <p className="text-gray-600">
                Try on garments in the privacy and comfort of your own home.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 flex items-center justify-center bg-amber-100 rounded-lg mb-4">
                <i className="ri-user-star-line text-3xl text-amber-700"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Personal Service</h3>
              <p className="text-gray-600">
                One-on-one attention from experienced tailors in a relaxed setting.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 flex items-center justify-center bg-amber-100 rounded-lg mb-4">
                <i className="ri-shield-check-line text-3xl text-amber-700"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Safe & Secure</h3>
              <p className="text-gray-600">
                Fully insured, background-checked professionals you can trust.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Welcome Section */}
      <section className="py-20 bg-gradient-to-b from-white to-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: '\"Playfair Display\", serif' }}>
              Welcome to Stitch&Style
            </h3>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              For nearly three decades, we have been New Jersey's premier destination for high-end alterations. 
              Our master seamstresses combine traditional craftsmanship with modern techniques to deliver 
              exceptional results that exceed expectations.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-8 bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center bg-amber-100 rounded-full mx-auto mb-4">
                <i className="ri-award-line text-3xl text-amber-700"></i>
              </div>
              <h4 className="text-2xl font-bold text-gray-900 mb-3">28+ Years</h4>
              <p className="text-gray-600">Of excellence in alteration services</p>
            </div>

            <div className="text-center p-8 bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center bg-amber-100 rounded-full mx-auto mb-4">
                <i className="ri-user-heart-line text-3xl text-amber-700"></i>
              </div>
              <h4 className="text-2xl font-bold text-gray-900 mb-3">10,000+</h4>
              <p className="text-gray-600">Satisfied customers served</p>
            </div>

            <div className="text-center p-8 bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center bg-amber-100 rounded-full mx-auto mb-4">
                <i className="ri-star-line text-3xl text-amber-700"></i>
              </div>
              <h4 className="text-2xl font-bold text-gray-900 mb-3">5-Star</h4>
              <p className="text-gray-600">Average customer rating</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: '\"Playfair Display\", serif' }}>
              Our Expert Services
            </h3>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              From wedding dresses to everyday wear, we handle all your alteration needs with precision and care.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-white to-amber-50 p-8 rounded-lg shadow-md hover:shadow-xl transition-all hover:-translate-y-1 border border-amber-100"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-amber-700 rounded-lg mb-4">
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h4>
                <p className="text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link
              to="/services"
              className="inline-block bg-amber-700 text-white px-8 py-4 rounded-md text-lg font-semibold hover:bg-amber-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              View All Services
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-4xl md:text-5xl font-bold mb-6" style={{ fontFamily: '\"Playfair Display\", serif' }}>
                Why Choose Stitch&Style?
              </h3>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-700 rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-check-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold mb-2">Expert Craftsmanship</h4>
                    <p className="text-gray-300">Our master seamstresses bring decades of experience to every garment.</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-700 rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-check-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold mb-2">Personalized Service</h4>
                    <p className="text-gray-300">We take time to understand your needs and deliver customized solutions.</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-700 rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-check-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold mb-2">Quick Turnaround</h4>
                    <p className="text-gray-300">Most alterations completed within 5-7 business days.</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-700 rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-check-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold mb-2">Quality Guarantee</h4>
                    <p className="text-gray-300">We stand behind our work with a satisfaction guarantee.</p>
                  </div>
                </div>
              </div>

              <Link
                to="/about"
                className="inline-block mt-8 bg-amber-700 text-white px-8 py-4 rounded-md text-lg font-semibold hover:bg-amber-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                Learn More About Us
              </Link>
            </div>

            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20seamstress%20carefully%20measuring%20and%20pinning%20elegant%20formal%20dress%20on%20mannequin%20in%20bright%20modern%20tailoring%20studio%20with%20natural%20light%20showing%20precision%20craftsmanship%20tools%20fabric%20swatches%20and%20sewing%20equipment%20in%20sophisticated%20workspace%20with%20warm%20neutral%20tones%20emphasizing%20quality%20and%20attention%20to%20detail&width=600&height=800&seq=why-choose-1&orientation=portrait"
                alt="Expert seamstress at work"
                className="rounded-lg shadow-2xl w-full h-auto object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: '\"Playfair Display\", serif' }}>
              What Our Clients Say
            </h3>
            <p className="text-xl text-gray-600">Don't just take our word for it</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white p-8 rounded-lg shadow-md">
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-500 text-xl"></i>
                  ))}
                </div>
                <p className="text-gray-700 mb-6 italic leading-relaxed">"{testimonial.text}"</p>
                <div>
                  <p className="font-bold text-gray-900">{testimonial.name}</p>
                  <p className="text-sm text-gray-600">{testimonial.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-amber-700 to-amber-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="text-4xl md:text-5xl font-bold mb-6" style={{ fontFamily: '\"Playfair Display\", serif' }}>
            Ready to Transform Your Wardrobe?
          </h3>
          <p className="text-xl mb-8">
            Schedule your consultation today and experience the Stitch&Style difference.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="bg-white text-amber-900 px-8 py-4 rounded-md text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Book Consultation
            </Link>
            <Link
              to="/pricelist"
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-md text-lg font-semibold hover:bg-white hover:text-amber-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              View Pricing
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
